export const anredeValues = ['Frau', 'Herr', 'divers'] as const;
export type Anrede = (typeof anredeValues)[number];

export function anredeValidator(val: string): Anrede {
  for (const a of anredeValues) {
    if (a === val) return a as Anrede;
  }
  throw new Error(`Value ${val} not supported in Anrede`);
}
